<template>
  <div class="container">
    <div class="table-title">
      <div>
        {{ $t("Setting.UserTable.Title") }}
      </div>
      <div class="table-actions">
        <div class="form-group input-group table-actions__input">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i
                class="fa fa-search"
                aria-hidden="true"
              />
            </div>
          </div>
          <datalist id="select-filter-words-list">
            <option
              v-for="(words, i) in filterWordsList"
              :key="i"
              :value="words"
            />
          </datalist>
          <input
            type="text"
            class="form-control text-autocomplete"
            v-model="filterWords"
            id="select-filter-words"
            autocomplete="on"
            list="select-filter-words-list"
            :placeholder="$t('Setting.UserTable.SearchInputPlaceholder')"
          >
        </div>
        <button
          type="button"
          class="btn btn-secondary table-actions__button"
          @click="isOpenModal = true"
          :disabled="selectedUser.length < 2"
        >
          {{ $t("Setting.UserTable.BulkEdit") }}
        </button>
      </div>
    </div>
    <table class="table">
      <!-- NOTE: Table Header -->
      <thead>
        <tr>
          <th scope="col" />
          <th scope="col">
            <a
              class="table-sort"
              :class="{
                'table-sort-up': sortObj.email === 'asc',
                'table-sort-down': sortObj.email === 'desc'
              }"
              @click="changeSortType('email')"
            >
              {{ $t("Setting.UserTable.Email") }}
            </a>
          </th>
          <th scope="col">
            <a
              class="table-sort"
              :class="{
                'table-sort-up': sortObj.nameJa === 'asc',
                'table-sort-down': sortObj.nameJa === 'desc'
              }"
              @click="changeSortType('nameJa')"
            >
              {{ $t("Setting.UserTable.NameJa") }}
            </a>
          </th>
          <th scope="col">
            <a
              class="table-sort"
              :class="{
                'table-sort-up': sortObj.nameEn === 'asc',
                'table-sort-down': sortObj.nameEn === 'desc'
              }"
              @click="changeSortType('nameEn')"
            >
              {{ $t("Setting.UserTable.NameEn") }}
            </a>
          </th>
          <th scope="col">
            <a
              class="table-sort"
              :class="{
                'table-sort-up': sortObj.license === 'asc',
                'table-sort-down': sortObj.license === 'desc'
              }"
              @click="changeSortType('license')"
            >
              {{ $t("Setting.UserTable.License") }}
            </a>
          </th>
          <th scope="col">
            <a
              class="table-sort"
              :class="{
                'table-sort-up': sortObj.role === 'asc',
                'table-sort-down': sortObj.role === 'desc'
              }"
              @click="changeSortType('role')"
            >
              {{ $t("Setting.UserTable.Role") }}
            </a>
          </th>
          <th scope="col">
            <a
              class="table-sort"
              :class="{
                'table-sort-up': sortObj.status === 'asc',
                'table-sort-down': sortObj.status === 'desc'
              }"
              @click="changeSortType('status')"
            >
              {{ $t("Setting.UserTable.Status") }}
            </a>
          </th>
        </tr>
      </thead>
      <!-- NOTE: Table Body -->
      <tbody>
        <tr
          v-for="item in filterdItems"
          :key="item.id"
        >
          <td>
            <label class="custom-control custom-checkbox">
              <input
                type="checkbox"
                v-model="item.isChecked"
              >
              <span class="custom-control-label" />
            </label>
          </td>
          <td @click="clickTable(item.id)">
            {{ item.email }}
          </td>
          <td @click="clickTable(item.id)">
            {{ item.nameJa }}
          </td>
          <td @click="clickTable(item.id)">
            {{ item.nameEn }}
          </td>
          <td @click="clickTable(item.id)">
            {{ item.license }}
          </td>
          <td @click="clickTable(item.id)">
            {{ item.role }}
          </td>
          <td @click="clickTable(item.id)">
            {{ item.status }}
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="table-empty"
      v-if="!filterdItems.length"
    >
      <div class="table-empty-label">
        {{ $t("General.NoData") }}
      </div>
    </div>

    <!-- NOTE: Pagenation -->
    <nav
      class="pagination"
      v-else
    >
      <p>
        {{ `${pagenationCount.start} - ${pagenationCount.end} of ${pagenationCount.all}` }}
      </p>
      <VSelectbox
        class="pagenation-step"
        :items="stepArray"
        select-id="select-step"
        size="sm"
        @selectedData="pageStep = $event"
      />
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-toolbar"
          :class="{'disabled':pagenationCount.start <= 1}"
          @click="subPagenationIndex"
        >
          <i class="fas fa-chevron-left" />
        </button>
        <button
          type="button"
          class="btn btn-toolbar"
          :class="{'disabled':pagenationCount.end >= pagenationCount.all}"
          @click="addPagenationIndex"
        >
          <i class="fas fa-chevron-right" />
        </button>
      </div>
    </nav>

    <!-- NOTE: Bulk Edit Modal -->
    <VModal
      :is-open.sync="isOpenModal"
      modal-full-width
    >
      <template #title>
        {{ $t("Setting.UserTable.BulkEdit") }}
      </template>
      <template #body>
        <div class="container">
          <!-- NOTE: Terget Users -->
          <div class="row">
            <div class="col-md-6">
              <ul class="list-group">
                <li class="list-group-item-header">
                  {{ $t("Setting.UserTable.Form.ListTitle") }}
                </li>
                <li
                  class="list-group-item"
                  v-for="user in selectedUser"
                  :key="user.id"
                >
                  {{ user.email }}
                </li>
              </ul>
            </div>
            <div class="col-md-6 bulk-select-container">
              <VSelectbox
                :items="bulkLicenseArray"
                select-id="select-bulk-license"
                :placeholder="$t('Setting.UserTable.Form.BulkLicensePlaceholder')"
                size="sm"
                @selectedData="selectedBulkLicense = $event"
              >
                <template #label>
                  {{ $t("Setting.UserTable.Form.BulkLicenseLabel") }}
                </template>
              </VSelectbox>
              <VSelectbox
                :items="bulkRoleArray"
                select-id="select-bulk-role"
                :placeholder="$t('Setting.UserTable.Form.BulkRolePlaceholder')"
                size="sm"
                @selectedData="selectedBulkRole = $event"
              >
                <template #label>
                  {{ $t("Setting.UserTable.Form.BulkRoleLabel") }}
                </template>
              </VSelectbox>
              <VSelectbox
                :items="bulkStatusArray"
                select-id="select-bulk-status"
                :placeholder="$t('Setting.UserTable.Form.BulkStatusPlaceholder')"
                size="sm"
                @selectedData="selectedBulkStatus = $event"
              >
                <template #label>
                  {{ $t("Setting.UserTable.Form.BulkStatusLabel") }}
                </template>
              </VSelectbox>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <button
          type="button"
          class="btn btn-primary"
          :disabled="!changedBulkData"
          @click="saveBulkData"
        >
          {{ $t("Setting.UserTable.Button.Update") }}
        </button>
        <button
          type="button"
          class="btn btn-outline-warning"
          @click="isOpenModal = false"
        >
          {{ $t("Setting.UserTable.Button.Cancel") }}
        </button>
      </template>
    </VModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VSelectbox from '@/components/VSelectbox'
import VModal from '@/components/VModal'

export default {
  components: {
    VSelectbox,
    VModal
  },
  props: {
    userData: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    editUserData: [],
    sortObj: {
      email: false,
      nameJa: false,
      nameEn: false,
      licence: false,
      role: false,
      status: false
    },
    filterWords: '',
    pageIndex: 0,
    pageStep: 10,
    isOpenModal: false,
    selectedBulkLicense: '',
    selectedBulkRole: '',
    selectedBulkStatus: '',
  }),
  computed: {
    ...mapState('auth', [
      'uid'
    ]),
    filterdItems() {
      return [].concat(this.editUserData).filter((obj) => {
        if (!this.filterWords) return true
        const words = `${obj.email}_${obj.license}_${obj.role}_${obj.status}_${obj.nameEn}_${obj.nameJa}`
        return words.indexOf(this.filterWords) >= 0
      }).slice(this.pagenationCount.start - 1, this.pagenationCount.end)
    },
    pagenationCount() {
      if (!Array.isArray(this.editUserData)) return { all: 0, start: 0, end: 0 }
      const all = this.editUserData.length
      const start = (this.pageStep * this.pageIndex) + 1
      const end = (this.pageStep * (this.pageIndex + 1))
      return {
        all,
        start,
        end: (end < all) ? end : all
      }
    },
    stepArray() {
      return [5, 10, 25, 50, 100].map((arr) => ({
        text: arr,
        value: arr,
        selected: this.pageStep === arr
      }))
    },
    filterWordsList() {
      const emailArr = [].concat(this.editUserData).reduce((acc, cur) => {
        if (acc.includes(cur.email)) return acc
        return [...acc, cur.email]
      }, [])
      const nameJaArr = [].concat(this.editUserData).reduce((acc, cur) => {
        if (acc.includes(cur.nameJa)) return acc
        return [...acc, cur.nameJa]
      }, [])
      const nameEnArr = [].concat(this.editUserData).reduce((acc, cur) => {
        if (acc.includes(cur.nameEn)) return acc
        return [...acc, cur.nameEn]
      }, [])
      const licenseArr = [].concat(this.editUserData).reduce((acc, cur) => {
        if (acc.includes(cur.license)) return acc
        return [...acc, cur.license]
      }, [])
      const roleArr = [].concat(this.editUserData).reduce((acc, cur) => {
        if (acc.includes(cur.role)) return acc
        return [...acc, cur.role]
      }, [])
      const statusArr = [].concat(this.editUserData).reduce((acc, cur) => {
        if (acc.includes(cur.status)) return acc
        return [...acc, cur.status]
      }, [])
      return [
        ...emailArr,
        ...nameJaArr,
        ...nameEnArr,
        ...licenseArr,
        ...roleArr,
        ...statusArr
      ]
    },
    selectedUser() {
      return this.editUserData.filter((obj) => obj.isChecked)
    },
    changedBulkData() {
      return [
        this.selectedBulkLicense,
        this.selectedBulkRole,
        this.selectedBulkStatus
      ].some((arr) => arr !== '')
    },
    bulkLicenseArray() {
      const selected = this.getAllSelectedData (this.selectedUser, 'license')
      return [
        this.$t('Setting.License.Standard'),
        this.$t('Setting.License.Trial'),
        this.$t('Setting.License.Free'),
      ].map((arr) => ({
        text: arr,
        value: arr,
        selected: !selected ? false : selected === arr
      }))
    },
    bulkRoleArray() {
      const selected = this.getAllSelectedData (this.selectedUser, 'role')
      return [
        this.$t('Setting.Role.Owner'),
        this.$t('Setting.Role.Admin'),
        this.$t('Setting.Role.Member'),
      ].map((arr) => ({
        text: arr,
        value: arr,
        selected: !selected ? false : selected === arr
      }))
    },
    bulkStatusArray() {
      const selected = this.getAllSelectedData (this.selectedUser, 'status')
      return [
        this.$t('Setting.Status.Inactive'),
        this.$t('Setting.Status.Active'),
      ].map((arr) => ({
        text: arr,
        value: arr,
        selected: !selected ? false : selected === arr
      }))
    },
  },
  watch: {
    userData: {
      handler: function(val, _) {
        this.editUserData = [].concat(val).map((obj, index) => {
          const result = {
            index,
            ...obj,
            isChecked: false
          }
          return Object.assign(result, {
            license: this.$t(`Setting.License.${obj.license}`),
            role: this.$t(`Setting.Role.${obj.role}`),
            status: this.$t(`Setting.Status.${obj.status}`)
          })
        })
      },
      deep: true
    },
    isOpenModal() {
      // NOTE: 変恋時に入力データをクリア
      this.selectedBulkLicense = ''
      this.selectedBulkRole = ''
      this.selectedBulkStatus = ''
    },
  },
  methods: {
    ...mapActions([
      'setLoadingState',
      'unsetLoadingState'
    ]),
    ...mapActions('scheduling', [
      'saveUserLicense',
      'saveUserRole',
      'saveUserStatus'
    ]),
    async saveBulkData() {
      console.log('taget', this.selectedUser)
      Promise.all([
        () => {
          if (this.selectedBulkLicense !== '') {
            return this.saveBulkLicense()
          }
        },
        () => {
          if (this.selectedBulkRole !== '') {
            return this.saveBulkRole()
          }
        },
        () => {
          if (this.selectedBulkStatus !== '') {
            return this.saveBulkStatus()
          }
        }
      ]).then(() => {
        this.isOpenModal = false
      })
    },
    async saveBulkLicense() {
      this.setLoadingState('saveBulkLicense')
      return await Promise.all(this.selectedUser.map( async (obj) => {
        return await this.saveUserLicense({
          uid: this.uid,
          userId: obj.id,
          license: this.selectedBulkLicense
        })
      })).finally(() => {
        this.unsetLoadingState('saveBulkLicense')
      })
    },
    async saveBulkRole() {
      this.setLoadingState('saveBulkRole')
      return await Promise.all(this.selectedUser.map( async (obj) => {
        return await this.saveUserRole({
          uid: this.uid,
          userId: obj.id,
          role: this.selectedBulkRole
        })
      })).finally(() => {
        this.unsetLoadingState('saveBulkRole')
      })
    },
    async saveBulkStatus() {
      this.setLoadingState('saveBulkStatus')
      return await Promise.all(this.selectedUser.map( async (obj) => {
        return await this.saveUserStatus({
          uid: this.uid,
          userId: obj.id,
          status: this.selectedBulkStatus
        })
      })).finally(() => {
        this.unsetLoadingState('saveBulkStatus')
      })
    },
    changeSortType(target) {
      if (!this.sortObj[target]) {
        this.$set(this.sortObj, target, 'asc')
      } else if (this.sortObj[target] === 'asc') {
        this.$set(this.sortObj, target, 'desc')
      } else {
        this.$set(this.sortObj, target, false)
      }
    },
    clickTable(id) {
      const target = this.editUserData.find((obj) => obj.id === id)
      if (!target || this.isOpenModal) return null
      this.editUserData[target.index].isChecked = !this.editUserData[target.index].isChecked
    },
    subPagenationIndex() {
      if (this.pagenationCount.start <= 1) return false
      this.pageIndex -= 1
    },
    addPagenationIndex() {
      if (this.pagenationCount.end >= this.pagenationCount.all) return false
      this.pageIndex += 1
    },
    getAllSelectedData (arr, target) {
      if (!Array.isArray(arr)) return false
      return arr.reduce((acc, cur) => {
        if (!acc) return false
        if (acc === true || acc === cur[target]) return cur[target]
        return false
      }, true)
    },
  }
}
</script>

<style lang="scss" scoped>
.table-title {
  display: flex;
  justify-content: space-between;
  padding-bottom: 24px;
}

.table-actions {
  width: 50%;
  display: flex;
  align-items: center;

  &__input {
    width: 20vw;
  }
  &__button {
    width: 10vw;
    margin-left: 12px;
  }
}

.text-autocomplete {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.list-group-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bulk-select-container {
  * + * {
    margin-top: 12px;
  }
}
</style>
